export const DB_NAME = "Fish";
export const DB_VERSION = 1;

export enum StoreName {}

export const URL_JUMP_BANK = "https://www.spacestation.company/"
export const URL_JUMP_ANDY_BOT = "https://andy-bot.com/"